import React, { useState, useEffect, useRef } from 'react';
import { Search, LayoutGrid, List, RefreshCw, Download, Upload, Filter, MoreVertical, Trash2, ChevronDown, ChevronUp, Plus, Send, Save, Settings } from 'lucide-react';
import Swal from 'sweetalert2';
import PremiumButton from '../../../Enquiries/Enquiries/components/PremiumButton';
import FollowupTooltip from './FollowupTooltip';
import { BsTelephonePlus } from "react-icons/bs";
import ScoreCard from '../../../../components/common/ScoreCard/ScoreCard';
import PopUpModal from '../../../../components/common/Modal';
import ScheduleCallForm from './ScheduleCallForm';
import Button from '../../../../components/common/Button';
import ImportData from '../../../../components/ImportData/ImportData';
import AddFollowupMassOperation from '../../../../components/LeadMass/AddFollowupMassOperation';
import AddAssignToMassOperation from '../../../../components/LeadMass/AddAssignToMassOperation';
import SendSMS from '../../../../components/LeadMass/SendSMS';
import SendMail from '../../../../components/LeadMass/SendMail';
import VoiceBroadCast from '../../../../components/LeadMass/VoiceBroadCast';
import UpdateForm from '../../../../components/LeadMass/UpdateForm';
import AddTaskForm from '../../../../components/LeadMass/AddTaskForm';
import AddAppointmentForm from '../../../../components/LeadMass/AddAppointmentForm';
import MarkettingSequence from '../../../../components/LeadMass/MarkettingSequence';
import SendInternationalSMS from '../../../../components/LeadMass/SendInternationalSMS';
import AddRemoveTag from '../../../../components/LeadMass/AddRemoveTag';
import AddCallList from '../../../../components/LeadMass/AddCallList';
import Modal from '../../../../components/common/Modal';
import AddLeadForm from '../../../../components/LeadForm/AddLeadForm';
import nodata from '../../../../assets/nodata.gif';
import { wcfInstance, serviceInstance } from '../../../../axiosinstance';
import { getInitials, getAvatarColorScheme } from '../../../../utils/helpers';
import { getSession } from '../../../../getSession';
import CustomButtonDropdown from './CustomButtonDropdown';
import WebhookParamsModal from './WebhookParamsModal';
import {
  buildInvokableUrl,
  checkWebhookUrl,
  fetchCustomButtonList,
  fetchLeadHeaderPlaceholders,
  invokeUrlByDisposition,
  parseWebhookParamConfig,
  resolveLeadId,
  updateWebhookParams
} from './customButtonsApi';

const LeadList = ({
  leads,
  selectedLead,
  onSelectLead,
  searchText,
  activeCustomSearchName,
  activeFilterText,
  onSearchChange,
  onSearch,
  onCustomSearchApply,
  isLoading,
  hasMore,
  onLoadMore,
  viewMode,
  setViewMode,
  totalRecord,
  itemsPerPage,
  setItemsPerPage,
  onRegisterExport,
  onRegisterImport
}) => {
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [scheduleLead, setScheduleLead] = useState(null);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [showToolbarMenu, setShowToolbarMenu] = useState(false);
  const [selectAllLeads, setSelectAllLeads] = useState(false);
  const toolbarMenuRef = useRef(null);
  const [showMoreActions, setShowMoreActions] = useState(false);
  const moreActionsRef = useRef(null);
  const [showSettingsMenu, setShowSettingsMenu] = useState(false);
  const settingsMenuRef = useRef(null);
  const columnSearchRef = useRef(null);
  const totalPages = Math.ceil(totalRecord / parseInt(itemsPerPage));
  const scrollContainerRef = useRef(null);
  const [isImportDataModal, setIsImportDataModal] = useState(false);
  const [massOperationBatchId, setMassOperationBatchId] = useState('');
  const [isBatchIdLoading, setIsBatchIdLoading] = useState(false);
  const [massOperationSelectedIds, setMassOperationSelectedIds] = useState([]);
  const [massOperationHashedIds, setMassOperationHashedIds] = useState('');

  // ---------------------------------------Mass Operation-----------------------------------
  const [isMassAddFollowupModal, setIsMassAddFollowupModal] = useState(false);
  const [isMassAddFollowupOperation, setIsMassAddFollowupOperation] = useState(false);
  const [isMassSendSMS, setIsMassSendSMS] = useState(false);
  const [isMassSendMail, setIsMassSendMail] = useState(false);
  const [isMassSendVoiceBroadCast, setIsMassSendVoiceBroadCast] = useState(false);
  const [isMassUpdateLead, setIsMassUpdateLead] = useState(false);
  const [isMassAddTask, setIsMassAddTask] = useState(false);
  const [isMassAddAppointment, setIsMassAddAppointment] = useState(false);
  const [isMassMsrketingSequence, setIsMassMarketingSequence] = useState(false);
  const [isSendInternationalSMS, setIsSendInternationalSMS] = useState(false);
  const [isMassAddTag, setIsMassAddTag] = useState(false);
  const [isAddTag, setIsAddTag] = useState(false);
  const [isMassAddCallList, setIsMassAddCallList] = useState(false);
  const [isDeleteMassConfirmModal, setDeleteMassConfirmModal] = useState({ show: false, leadId: null });
  const [massSmsSubmitHandler, setMassSmsSubmitHandler] = useState(null);
  const [massMailSubmitHandler, setMassMailSubmitHandler] = useState(null);
  const [massVoiceSubmitHandler, setMassVoiceSubmitHandler] = useState(null);
  const [massSequenceSubmitHandler, setMassSequenceSubmitHandler] = useState(null);
  const [massInternationalSmsSubmitHandler, setMassInternationalSmsSubmitHandler] = useState(null);
  const [massTagSubmitHandler, setMassTagSubmitHandler] = useState(null);
  const [massTaskSubmitHandler, setMassTaskSubmitHandler] = useState(null);
  const [massAppointmentSubmitHandler, setMassAppointmentSubmitHandler] = useState(null);
  const [massAssignSubmitHandler, setMassAssignSubmitHandler] = useState(null);
  const [massFollowupSubmitHandler, setMassFollowupSubmitHandler] = useState(null);
  const [massUpdateSubmitHandler, setMassUpdateSubmitHandler] = useState(null);
  const [massCallListSubmitHandler, setMassCallListSubmitHandler] = useState(null);
  const [importSubmitHandler, setImportSubmitHandler] = useState(null);
  const [isAddLeadModal, setIsAddLeadModal] = useState(false);
  // PDF modal state
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [pdfLeadNo, setPdfLeadNo] = useState('');
  const [pdfLeadId, setPdfLeadId] = useState(null);
  const [pdfHeaders, setPdfHeaders] = useState([]);
  const [pdfPrefs, setPdfPrefs] = useState([]);
  const [pdfSelectedCols, setPdfSelectedCols] = useState(new Set());
  const [pdfTimeStamp, setPdfTimeStamp] = useState(false);
  const [pdfCreatedBy, setPdfCreatedBy] = useState(false);
  const [pdfPageNo, setPdfPageNo] = useState(false);
  const [pdfTitle, setPdfTitle] = useState('');
  const [customButtons, setCustomButtons] = useState([]);
  const [leadPlaceholders, setLeadPlaceholders] = useState([]);
  const [customSearchOptions, setCustomSearchOptions] = useState([]);
  const [selectedCustomSearch, setSelectedCustomSearch] = useState('');
  const [isCustomSearchLoading, setIsCustomSearchLoading] = useState(false);
  const [isSavingCustomSearch, setIsSavingCustomSearch] = useState(false);
  const [webhookModalState, setWebhookModalState] = useState({
    open: false,
    webhookId: '',
    requiredParams: {},
    leadIds: [],
    batchId: '',
    title: 'Webhook Parameters'
  });

  // ---------------------------------------End Mass Operation-------------------------------

  const { userId, parentId, TokenId, token } = getSession();
  const [isExporting, setIsExporting] = useState(false);

  // Click-outside: close three-dot dropdown
  useEffect(() => {
    if (!showMoreActions) return;
    const handler = (e) => {
      if (moreActionsRef.current && !moreActionsRef.current.contains(e.target)) {
        setShowMoreActions(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [showMoreActions]);

  // Click-outside: close toolbar menu (showToolbarMenu)
  useEffect(() => {
    if (!showToolbarMenu) return;
    const handler = (e) => {
      if (toolbarMenuRef.current && !toolbarMenuRef.current.contains(e.target)) {
        setShowToolbarMenu(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [showToolbarMenu]);

  // Click-outside: close settings menu
  useEffect(() => {
    if (!showSettingsMenu) return;
    const handler = (e) => {
      if (settingsMenuRef.current && !settingsMenuRef.current.contains(e.target)) {
        setShowSettingsMenu(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [showSettingsMenu]);

  // Register export/import functions so parent (global header) can trigger them
  useEffect(() => {
    if (onRegisterExport) onRegisterExport(handleExportLeadList);
    if (onRegisterImport) onRegisterImport(() => setIsImportDataModal(true));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const parseWcfList = (payload) => {
    let data = payload?.d ?? payload?.Data ?? payload?.data ?? payload?.Details ?? payload;

    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (error) {
        return [];
      }
    }

    if (data && Array.isArray(data.data)) return data.data;
    if (Array.isArray(data)) return data;
    return [];
  };

  const getCustomSearchOptionText = (item) => {
    const directValue = String(
      item?.SearchName
      ?? item?.searchName
      ?? item?.CriteriaName
      ?? item?.criteriaName
      ?? item?.CustomSearchName
      ?? item?.customSearchName
      ?? item?.Name
      ?? item?.name
      ?? item?.Text
      ?? item?.text
      ?? ''
    ).trim();

    if (directValue) return directValue;

    const fallbackEntry = Object.entries(item || {}).find(([key, value]) => {
      const normalizedKey = String(key || '').toLowerCase();
      if (['id', 'searchid', 'userid', 'criteriatype', 'status', 'count'].includes(normalizedKey)) return false;
      return typeof value === 'string' && String(value).trim();
    });

    return fallbackEntry ? String(fallbackEntry[1]).trim() : '';
  };

  const loadLeadCustomSearch = async () => {
    if (!userId) {
      setCustomSearchOptions([]);
      return;
    }

    try {
      setIsCustomSearchLoading(true);
      const response = await wcfInstance.post(
        'UserCRMCampaign/Service/LeadAssignmentService.asmx/getLeadCustomSearch',
        { strUserID: String(userId) }
      );
      const list = parseWcfList(response?.data ?? response);
      const normalized = list
        .map((item, index) => {
          const optionText = getCustomSearchOptionText(item);
          return {
            id: item?.Id ?? item?.ID ?? item?.SearchId ?? item?.searchId ?? `${optionText}-${index}`,
            value: optionText,
            label: optionText,
            raw: item
          };
        })
        .filter((item) => item.value);

      setCustomSearchOptions(normalized);
    } catch (error) {
      console.error('getLeadCustomSearch error:', error);
      setCustomSearchOptions([]);
    } finally {
      setIsCustomSearchLoading(false);
    }
  };

  const handleCustomSearchAction = async (action) => {
    const searchName = String(selectedCustomSearch || '').trim();

    if (!searchName) {
      Swal.fire({ icon: 'warning', title: 'OOPs', text: 'Please select search name from list.' });
      return;
    }

    if (action === 'apply') {
      if (typeof onCustomSearchApply === 'function') {
        onCustomSearchApply(searchName);
      }
      return;
    }

    if (action !== 'save_apply') {
      Swal.fire({ icon: 'warning', title: 'OOPs', text: 'Invalid Action Button' });
      return;
    }

    try {
      setIsSavingCustomSearch(true);
      const response = await wcfInstance.post(
        'UserCRMCampaign/Service/CRMService.asmx/ManageDefaultSearchName',
        {
          UserId: userId,
          SearchType: 'LD',
          SearchName: searchName
        }
      );
      const payload = response?.data ?? response;
      const isSuccess = payload?.d ?? payload?.Data ?? payload?.data ?? payload?.Details ?? false;

      if (isSuccess) {
        if (typeof onCustomSearchApply === 'function') {
          onCustomSearchApply(searchName);
        }
        return;
      }

      Swal.fire({ icon: 'warning', title: 'OOPs', text: 'Unable to process your request please contact administrator or support team.' });
    } catch (error) {
      console.error('ManageDefaultSearchName error:', error);
      Swal.fire({ icon: 'warning', title: 'OOPs', text: 'Unable to process your request please contact administrator or support team.' });
    } finally {
      setIsSavingCustomSearch(false);
    }
  };

  const getStatusColor = (lead) => {
    return 'bg-green-100 text-green-700';
  };

  const getBadgeColor = (count) => {
    const num = count || 0;
    if (num === 0) return 'bg-gray-400';
    if (num === 1) return 'bg-green-400';
    if (num === 2) return 'bg-green-500';
    if (num === 3) return 'bg-lime-500';
    if (num === 4) return 'bg-yellow-400';
    if (num === 5) return 'bg-yellow-500';
    if (num === 6) return 'bg-orange-400';
    if (num === 7) return 'bg-orange-500';
    if (num === 8) return 'bg-red-400';
    if (num === 9) return 'bg-red-500';
    if (num >= 10) return 'bg-red-600';
    return 'bg-blue-500';
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedLeads(leads.map(lead => lead.ID));
      setSelectAllLeads(false); // Uncheck "Apply on All" when selecting current page
      setMassOperationBatchId('');
    } else {
      setSelectedLeads([]);
      setSelectAllLeads(false);
      setMassOperationBatchId('');
    }
  };

  const handleSelectAllLeads = (e) => {
    if (e.target.checked) {
      setSelectAllLeads(true);
      // Select all on current page as well
      setSelectedLeads(leads.map(lead => lead.ID));
    } else {
      setSelectAllLeads(false);
      setSelectedLeads([]);
      setMassOperationBatchId('');
    }
  };

  const getMassOperationLeadId = async (massType) => {
    const loggedInUserId = Number(localStorage.getItem('userId')) || 0;
    const params = {
      criteriaName: searchText || '',
      SearchLeadFilter: searchText || '',
      FilterText: '',
      UserId: loggedInUserId,
      orderStr: '',
      massType,
      endPoint: Number(totalRecord || 0)
    };

    const response = await wcfInstance.post(
      'UserCRMCampaign/Service/LeadService.asmx/GetMassOperationLeadID',
      params
    );

    const payload = response?.data;
    const batchId = payload?.d ?? payload?.Data ?? payload?.data ?? payload?.Details ?? payload;

    if (!batchId) {
      throw new Error('Batch ID was not returned from GetMassOperationLeadID');
    }

    const normalizedBatchId = String(batchId);
    setMassOperationBatchId(normalizedBatchId);
    return normalizedBatchId;
  };

  const openMassOperation = async (massType, openModal) => {
    if (!selectAllLeads) {
      openModal();
      return;
    }

    try {
      setIsBatchIdLoading(true);
      await getMassOperationLeadId(massType);
      openModal();
    } catch (error) {
      console.error('GetMassOperationLeadID error:', error);
      window.alert('Unable to start mass operation. Please try again.');
    } finally {
      setIsBatchIdLoading(false);
    }
  };

  const handleSelectLead = (leadId) => {
    setSelectedLeads(prev => {
      if (prev.includes(leadId)) {
        return prev.filter(id => id !== leadId);
      } else {
        return [...prev, leadId];
      }
    });
  };

  useEffect(() => {
    if (selectAllLeads) {
      setMassOperationSelectedIds([]);
      setMassOperationHashedIds('');
      return;
    }

    const selectedIds = selectedLeads
      .map(id => `${id}`)
      .filter(Boolean);

    setMassOperationSelectedIds(selectedIds);
    setMassOperationHashedIds(selectedIds.join('/'));
  }, [selectedLeads, selectAllLeads]);

  const massOperationSelectionProps = {
    selectedLeadIds: massOperationSelectedIds,
    hashedIds: massOperationHashedIds,
    massOpBatchId: massOperationBatchId,
    applyOnAllLeads: selectAllLeads
  };

  const handleMassDelete = async () => {
    const batchId = String(massOperationBatchId || '').trim();
    const hashedIds = String(massOperationHashedIds || '').trim();
    const commaSeparatedHashedIds = hashedIds.replace(/\//g, ',');
    const currentDate = new Date().toISOString().split('T')[0];
    const userId = Number(localStorage.getItem('userId')) || 0;

    if (!selectAllLeads && !commaSeparatedHashedIds) {
      window.alert('No leads selected for delete.');
      return;
    }

    if (selectAllLeads && !batchId) {
      window.alert('Batch id missing for apply-on-all delete. Please try again.');
      return;
    }

    const params = {
      hashedIds: selectAllLeads ? '' : commaSeparatedHashedIds,
      Batchid: selectAllLeads ? batchId : '',
      massbatchid: selectAllLeads ? batchId : '',
      MassOperationName: 'Delete',
      EntityType: 'Lead',
      Scheduledatetimelead: currentDate,
      UserId: userId
    };

    try {
      const response = await wcfInstance.post(
        'UserCRMCampaign/Service/CRMService.asmx/MassDeleteHashedLeadEnquiry',
        params
      );

      const payload = response?.data;
      const message = payload?.d ?? payload?.Message ?? payload?.Details ?? 'Selected records have been scheduled for deletion.';
      window.alert(typeof message === 'string' ? message : 'Selected records have been scheduled for deletion.');

      setDeleteMassConfirmModal({ show: false, leadId: null });
      setSelectedLeads([]);
      setSelectAllLeads(false);
      setMassOperationBatchId('');
      setMassOperationSelectedIds([]);
      setMassOperationHashedIds('');
      window.location.reload();
    } catch (error) {
      console.error('MassDeleteHashedLeadEnquiry error:', error);
      window.alert('Failed to schedule mass delete. Please try again.');
    }
  };

  // Infinite scroll handler
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;
      // Trigger load more when scrolled to within 100px of bottom
      if (scrollHeight - scrollTop - clientHeight < 100 && hasMore && !isLoading) {
        onLoadMore();
      }
    };

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [hasMore, isLoading, onLoadMore]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (toolbarMenuRef.current && !toolbarMenuRef.current.contains(event.target)) {
        setShowToolbarMenu(false);
      }
      if (moreActionsRef.current && !moreActionsRef.current.contains(event.target)) {
        setShowMoreActions(false);
      }
    };

    if (showMoreActions || showToolbarMenu) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [showToolbarMenu, showMoreActions]);

  useEffect(() => {
    const loadCustomButtonDependencies = async () => {
      try {
        const [buttons, placeholders] = await Promise.all([
          fetchCustomButtonList('Leads'),
          fetchLeadHeaderPlaceholders()
        ]);
        setCustomButtons(Array.isArray(buttons) ? buttons : []);
        setLeadPlaceholders(Array.isArray(placeholders) ? placeholders : []);
      } catch (error) {
        console.error('Failed to load custom buttons:', error);
      }
    };

    loadCustomButtonDependencies();
  }, []);

  // Fetch headers/preferences when pdfModalOpen toggles on
  useEffect(() => {
    if (!pdfModalOpen) return;
    let mounted = true;

    (async () => {
      try {
        const hdrResp = await serviceInstance.get('UserCRM/GetHeaders_Click');
        const hdrBody = hdrResp?.data ?? hdrResp;
        const headers = hdrBody?.Details ?? hdrBody?.details ?? hdrBody?.d ?? hdrBody;
        const parsedHeaders = Array.isArray(headers) ? headers : (typeof headers === 'string' ? JSON.parse(headers) : []);
        if (!mounted) return;
        setPdfHeaders(parsedHeaders);

        const reqPayload = {
          Token: TokenId || token || '',
          Message: '',
          LoggedUserId: userId || 0,
          MAC_Address: '',
          IP_Address: '',
          Details: { UserID: userId || 0, ParentId: parentId || 0, ParentID: parentId || 0 },
          BroadcastName: ''
        };

        const prefResp = await serviceInstance.post('UserCRM/GetPreferenceCol', reqPayload);
        const prefBody = prefResp?.data ?? prefResp;
        const prefs = prefBody?.Details ?? prefBody?.details ?? prefBody?.d ?? prefBody;

        // Normalize prefs into an array of strings.
        let parsedPrefs = [];
        if (Array.isArray(prefs)) {
          // Some responses return a single comma-separated string inside an array.
          if (prefs.length === 1 && typeof prefs[0] === 'string' && prefs[0].includes(',')) {
            parsedPrefs = prefs[0].split(',').map(s => String(s || '').trim()).filter(Boolean);
          } else {
            parsedPrefs = prefs.map(p => (p == null ? '' : String(p).trim())).filter(Boolean);
          }
        } else if (typeof prefs === 'string') {
          if (prefs.includes(',')) {
            parsedPrefs = prefs.split(',').map(s => String(s || '').trim()).filter(Boolean);
          } else {
            try {
              const maybe = JSON.parse(prefs);
              parsedPrefs = Array.isArray(maybe) ? maybe.map(p => String(p || '').trim()).filter(Boolean) : [String(maybe || '').trim()].filter(Boolean);
            } catch {
              parsedPrefs = [prefs].map(s => String(s || '').trim()).filter(Boolean);
            }
          }
        } else if (prefs) {
          parsedPrefs = [String(prefs)].map(s => s.trim()).filter(Boolean);
        }

        if (!mounted) return;
        setPdfPrefs(parsedPrefs || []);
        // initialize selected cols based on prefs
        const setCols = new Set();
        (parsedPrefs || []).forEach(p => { if (p) setCols.add(p); });
        setPdfSelectedCols(setCols);
        // check special flags if prefs contain them (case-insensitive)
        const lowerPrefs = (parsedPrefs || []).map(p => String(p || '').toLowerCase());
        setPdfTimeStamp(lowerPrefs.includes('timestamp'));
        setPdfCreatedBy(lowerPrefs.includes('created_by') || lowerPrefs.includes('created_by'.toLowerCase()));
        setPdfPageNo(lowerPrefs.includes('pageno'));
      } catch (err) {
        console.error('Error fetching PDF headers/prefs', err);
      }
    })();

    return () => { mounted = false; };
  }, [pdfModalOpen]);

  useEffect(() => {
    loadLeadCustomSearch();
  }, [userId]);

  // Helpers for PDF modal actions
  const getHeaderName = (h) => {
    if (!h) return '';
    return String(h?.ColumnName ?? h?.columnName ?? h?.Header ?? h?.header ?? h?.Field ?? h?.field ?? h).trim();
  };

  const togglePdfColumn = (col) => {
    setPdfSelectedCols((prev) => {
      const s = new Set(prev);
      if (s.has(col)) s.delete(col);
      else s.add(col);
      return s;
    });
  };

  const handleSelectAllPdf = () => {
    const allCols = (pdfHeaders || []).map(h => getHeaderName(h)).filter(Boolean);
    const allSelected = allCols.length > 0 && allCols.every(c => pdfSelectedCols.has(c));
    setPdfSelectedCols(allSelected ? new Set() : new Set(allCols));
  };

  const handleGeneratePdf = () => {
    (async () => {
      try {
        const flags = [];
        if (pdfTimeStamp) flags.push('TimeStamp');
        if (pdfCreatedBy) flags.push('Created_By');
        if (pdfPageNo) flags.push('PageNo');

        const selectedValues = Array.from(pdfSelectedCols || []);

        const reqPayload = {
          Token: TokenId || token || '',
          Message: '',
          LoggedUserId: userId || 0,
          MAC_Address: '',
          IP_Address: '',
          Details: {
            leadNo: Number(pdfLeadNo || 0),
            LeadNo: Number(pdfLeadNo || 0),
            title: String(pdfTitle || ''),
            Title: String(pdfTitle || ''),
            checkboxestop: flags.join(','),
            checkboxesTop: flags.join(','),
            selectedValues: selectedValues,
            SelectedValues: selectedValues,
            UserID: userId || 0,
            ParentId: parentId || 0,
            ParentID: parentId || 0
          },
          BroadcastName: ''
        };

        const resp = await serviceInstance.post('UserCRM/DownloadLeadDetailsPdf', reqPayload, { responseType: 'blob' });

        // Try to determine filename from content-disposition
        const cd = resp.headers && (resp.headers['content-disposition'] || resp.headers['Content-Disposition']);
        let filename = `LeadDetails_${pdfLeadNo || ''}.pdf`;
        if (cd) {
          const m = cd.match(/filename\*=UTF-8''([^;\n\r]+)|filename="?([^";]+)"?/i);
          if (m) {
            filename = decodeURIComponent((m[1] || m[2] || filename).replace(/\"/g, ''));
          }
        }

        const blob = new Blob([resp.data], { type: resp.data.type || 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        setPdfModalOpen(false);
      } catch (err) {
        console.error('PDF generation failed', err);
        // Attempt to parse error blob as JSON/text
        try {
          if (err?.response && err.response.data) {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const txt = reader.result;
                console.error('Server response:', txt);
                window.alert('Unable to generate PDF. Server returned an error.');
              } catch {
                window.alert('Unable to generate PDF.');
              }
            };
            reader.readAsText(err.response.data);
            return;
          }
        } catch (e) { /* ignore */ }
        window.alert('Unable to generate PDF. Please try again.');
      }
    })();
  };

  const getInListActionTargets = async () => {
    if (selectAllLeads) {
      const batchId = massOperationBatchId || await getMassOperationLeadId('Send Mail');
      if (!batchId) {
        throw new Error('Batch ID missing for apply-on-all action.');
      }
      return {
        leadIds: [],
        batchId: String(batchId)
      };
    }

    const selectedIds = selectedLeads
      .map((item) => String(item || '').trim())
      .filter(Boolean);

    if (!selectedIds.length) {
      throw new Error('Select at least one lead to run this custom button.');
    }

    return {
      leadIds: selectedIds,
      batchId: ''
    };
  };

  const submitWebhookAction = async ({ webhookId, params, leadIds, batchId, headerKey, headerValue, senderId }) => {
    await updateWebhookParams({
      webhookId,
      params,
      leadIds,
      batchId,
      headerKey,
      headerValue,
      senderId
    });
    window.alert('Webhook parameters updated successfully and button service started.');
  };

  const handleCustomButtonAction = async (button, explicitLeadId = null) => {
    try {
      const action = String(button?.ActionBePerform || '').trim();
      const placeOnPage = String(button?.PlaceOnPage || '').trim();
      const details = String(button?.ActionDetails || '');
      const disposition = String(button?.ButtonDisposition || 'Existing Tab');
      const buttonId = button?.ButtonId;

      let targets = { leadIds: [], batchId: '' };

      if (placeOnPage.toLowerCase() === 'inrecord') {
        const oneId = explicitLeadId ? String(explicitLeadId) : '';
        if (!oneId) {
          window.alert('Lead id not found for this record.');
          return;
        }
        targets = { leadIds: [oneId], batchId: '' };
      } else {
        targets = await getInListActionTargets();
      }

      if (action === 'Invoke a URL') {
        if (!targets.leadIds.length) {
          window.alert('Invoke URL works with selected leads only. Please select one or more leads.');
          return;
        }
        const finalUrl = await buildInvokableUrl(details, targets.leadIds);
        invokeUrlByDisposition(finalUrl, disposition);
        return;
      }

      if (action !== 'Webhook') {
        window.alert(`Unsupported action: ${action || 'Unknown'}`);
        return;
      }

      const webhookDetailsList = await checkWebhookUrl({
        buttonId,
        webhookURL: details,
        batchId: targets.batchId
      });

      if (!Array.isArray(webhookDetailsList) || !webhookDetailsList.length) {
        window.alert('No webhook details found in response.');
        return;
      }

      const parsed = parseWebhookParamConfig(webhookDetailsList[0]);
      if (!parsed.webhookId) {
        window.alert('Webhook ID missing in response.');
        return;
      }

      const requiredParamKeys = Object.keys(parsed.requiredParams || {});
      if (!requiredParamKeys.length) {
        await submitWebhookAction({
          webhookId: parsed.webhookId,
          params: {},
          leadIds: targets.leadIds,
          batchId: targets.batchId,
          headerKey: '',
          headerValue: '',
          senderId: ''
        });
        return;
      }

      setWebhookModalState({
        open: true,
        webhookId: parsed.webhookId,
        requiredParams: parsed.requiredParams,
        leadIds: targets.leadIds,
        batchId: targets.batchId,
        title: button?.ButtonName ? `Webhook: ${button.ButtonName}` : 'Webhook Parameters'
      });
    } catch (error) {
      console.error('Custom button execution failed:', error);
      window.alert(error?.message || 'Failed to execute custom button action.');
    }
  };

  const parseBlobJson = async (blob) => {
    if (!blob || typeof blob.text !== 'function') return null;
    try {
      const text = await blob.text();
      if (!text) return null;
      return JSON.parse(text);
    } catch {
      return null;
    }
  };

  const handleExportLeadList = async () => {
    try {
      setShowToolbarMenu(false);
      setIsExporting(true);

      Swal.fire({
        title: 'Exporting',
        text: 'Please wait while your leads are being exported...',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const selectedIds = Array.isArray(selectedLeads)
        ? selectedLeads.map((id) => String(id || '').trim()).filter(Boolean)
        : [];
      const hasSelectedRecords = selectedIds.length > 0;
      const totalRecords = hasSelectedRecords ? selectedIds.length : Number(totalRecord || 0);

      const exportData = {
        UserId: String(userId || ''),
        ParentId: String(parentId || ''),
        SearchName: String(activeCustomSearchName || ''),
        FilterText: String(activeFilterText || ''),
        OrderStr: '',
        NotFollowUp: 0,
        TextSearch: String('' || ''),
        startPoint: 1,
        endPoint: totalRecords
      };

      if (hasSelectedRecords) {
        exportData.selectedIds = selectedIds;
      }

      const response = await wcfInstance.post(
        'UserCRMCampaign/Service/LeadService.asmx/ExportLeadList',
        exportData,
        {
          responseType: 'blob',
          validateStatus: () => true
        }
      );

      Swal.close();

      const statusCode = response?.status;
      const contentType = String(response?.headers?.['content-type'] || '').toLowerCase();
      const blobData = response?.data;

      if (statusCode === 202 || contentType.includes('application/json')) {
        const parsed = await parseBlobJson(blobData);
        const infoMsg = parsed?.batchId
          ? `${parsed?.message || 'Export request logged for background processing.'} Batch ID: ${parsed.batchId}`
          : (parsed?.message || 'Export request has been logged for background processing. You will receive notification when export is ready.');
        Swal.fire('Info', infoMsg, 'info');
        return;
      }

      if (statusCode === 200 && (contentType.includes('excel') || contentType.includes('spreadsheet') || contentType.includes('octet-stream'))) {
        const blob = new Blob([blobData], { type: 'application/vnd.ms-excel' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `LeadExport_${new Date().getTime()}.xls`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
        Swal.fire('Success', 'Export downloaded successfully.', 'success');
        return;
      }

      if (statusCode >= 200 && statusCode < 300) {
        Swal.fire('Success', 'Export completed successfully.', 'success');
      } else {
        Swal.fire('Error', 'An error occurred during export. Please try again.', 'error');
      }
    } catch (error) {
      Swal.close();
      console.error('Export error:', error);
      Swal.fire('Error', 'Error exporting Lead Details, please try again or contact support.', 'error');
    } finally {
      setIsExporting(false);
    }
  };

  useEffect(() => {
    setSelectedCustomSearch(activeCustomSearchName || '');
  }, [activeCustomSearchName]);

  return (
    <div className="bg-white border-r border-gray-200 flex flex-col h-full">
      {/* Subheader toolbar */}
      <div className="px-3 py-2 border-b border-gray-200 flex items-center gap-2 bg-gray-50">
        {/* Checkbox — always show in card/split mode */}
        <input
          type="checkbox"
          checked={selectedLeads.length === leads.length && leads.length > 0}
          onChange={handleSelectAll}
          className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer flex-shrink-0"
          title="Select All"
        />

        {/* Selected count pill — only when items selected */}
        {selectedLeads.length > 0 && (
          <span className="text-xs font-semibold text-blue-700 bg-blue-100 rounded-full px-2 py-0.5 flex-shrink-0">
            {selectAllLeads ? `All ${totalRecord}` : selectedLeads.length}
          </span>
        )}

        {/* Apply on all strip */}
        {selectedLeads.length === leads.length && totalRecord > leads.length && (
          <label className="flex items-center gap-1 text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-0.5 cursor-pointer flex-shrink-0">
            <input
              type="checkbox"
              checked={selectAllLeads}
              onChange={handleSelectAllLeads}
              className="w-3 h-3 rounded border-amber-300 text-amber-600 focus:ring-amber-500 cursor-pointer"
            />
            All {totalRecord}
          </label>
        )}

        {/* Three-dot menu — contains all mass operations */}
        <div className="relative flex-shrink-0" ref={moreActionsRef}>
          <button
            onClick={() => setShowMoreActions(!showMoreActions)}
            className={`p-1.5 rounded transition flex items-center justify-center ${selectedLeads.length > 0 ? 'hover:bg-gray-200 text-gray-700' : 'text-gray-300 cursor-not-allowed'}`}
            title={selectedLeads.length > 0 ? 'Actions' : 'Select leads first'}
            disabled={selectedLeads.length === 0}
          >
            <MoreVertical className="w-4 h-4" />
          </button>

          {showMoreActions && selectedLeads.length > 0 && (
            <div className="absolute left-0 top-full mt-1 w-52 bg-white border border-gray-200 rounded-lg shadow-lg z-[1003]">
              {/* Header with count */}
              <div className="px-3 py-2 border-b border-gray-100 bg-gray-50 rounded-t-lg flex items-center justify-between">
                <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                  {selectAllLeads ? `All ${totalRecord} selected` : `${selectedLeads.length} selected`}
                </span>
                <button
                  onClick={() => { setSelectedLeads([]); setSelectAllLeads(false); setMassOperationBatchId(''); setShowMoreActions(false); }}
                  className="text-xs text-red-500 hover:text-red-700 transition font-medium"
                >
                  Clear
                </button>
              </div>
              <div className="py-1">
                <button
                  onClick={() => { openMassOperation('AssignTo', () => setIsMassAddFollowupModal(true)); setShowMoreActions(false); }}
                  disabled={isBatchIdLoading}
                  className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50 transition"
                >
                  AssignTo
                </button>
                <button
                  onClick={() => { openMassOperation('Send SMS', () => setIsMassSendSMS(true)); setShowMoreActions(false); }}
                  disabled={isBatchIdLoading}
                  className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50 transition"
                >
                  Send SMS
                </button>
                <button
                  onClick={() => { openMassOperation('Send Mail', () => setIsMassSendMail(true)); setShowMoreActions(false); }}
                  disabled={isBatchIdLoading}
                  className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50 transition"
                >
                  Send Mail
                </button>
                <button
                  onClick={() => { openMassOperation('Voice Broadcast', () => setIsMassSendVoiceBroadCast(true)); setShowMoreActions(false); }}
                  disabled={isBatchIdLoading}
                  className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50 transition"
                >
                  Voice Broadcast
                </button>
                <button
                  onClick={() => { openMassOperation('Update', () => setIsMassUpdateLead(true)); setShowMoreActions(false); }}
                  disabled={isBatchIdLoading}
                  className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50 transition"
                >
                  Update
                </button>
                <div className="border-t border-gray-100 mt-1 pt-1">
                  <button
                    onClick={() => { openMassOperation('Add Followup', () => setIsMassAddFollowupOperation(true)); setShowMoreActions(false); }}
                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition"
                  >
                    Add Followup
                  </button>
                  <button
                    onClick={() => { openMassOperation('Add Task', () => setIsMassAddTask(true)); setShowMoreActions(false); }}
                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition"
                  >
                    Add Task
                  </button>
                  <button
                    onClick={() => { openMassOperation('Add Appointment', () => setIsMassAddAppointment(true)); setShowMoreActions(false); }}
                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition"
                  >
                    Add Appointment
                  </button>
                  <button
                    onClick={() => { openMassOperation('Marketting Sequence', () => setIsMassMarketingSequence(true)); setShowMoreActions(false); }}
                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition"
                  >
                    Marketing Sequence
                  </button>
                  <button
                    onClick={() => { openMassOperation('Send International SMS', () => setIsSendInternationalSMS(true)); setShowMoreActions(false); }}
                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition"
                  >
                    Send International SMS
                  </button>
                  <button
                    onClick={() => { openMassOperation('Add Tag', () => { setIsMassAddTag(true); setIsAddTag(true); }); setShowMoreActions(false); }}
                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition"
                  >
                    Add Tag
                  </button>
                  <button
                    onClick={() => { openMassOperation('Remove Tag', () => { setIsMassAddTag(true); setIsAddTag(false); }); setShowMoreActions(false); }}
                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition"
                  >
                    Remove Tag
                  </button>
                  <button
                    onClick={() => { openMassOperation('Add Call List', () => setIsMassAddCallList(true)); setShowMoreActions(false); }}
                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition"
                  >
                    Add Call List
                  </button>
                  <button
                    onClick={() => { openMassOperation('Delete', () => setDeleteMassConfirmModal({ show: true, leadId: null })); setShowMoreActions(false); }}
                    className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>


        {/* Spacer */}
        <div className="flex-1" />

        {/* Custom Buttons (admin-configured custom button) */}
        <div className="flex-shrink-0" ref={toolbarMenuRef}>
          <CustomButtonDropdown
            buttons={customButtons}
            placeOnPage="InList"
            onButtonClick={(button) => handleCustomButtonAction(button)}
          />
        </div>
      </div>

      <input type="hidden" id="hdnfld_MassOpBatchId" value={massOperationBatchId} readOnly />
      <input type="hidden" id="HashedIds" value={massOperationHashedIds} readOnly />

      {/* Lead List */}
      <div ref={scrollContainerRef} className="flex-1 overflow-y-auto overflow-x-visible">
        {isLoading && leads.length === 0 ? (
          <div className="p-4 flex items-center justify-center">
            <RefreshCw className="w-5 h-5 animate-spin text-blue-600" />
            <span className="ml-2 text-sm text-gray-600">Loading...</span>
          </div>
        ) : leads.length === 0 ? (
          <div className="flex flex-col items-center justify-center p-8 py-20 bg-white flex-1">
            <img
              src={nodata}
              alt="No Record Found"
              style={{ width: '350px', height: 'auto', marginBottom: '16px' }}
            />
            <p className="text-[15px] font-semibold text-[#444444]">
              No record Found.
            </p>
          </div>
        ) : (
          leads.map((lead) => (
            <div
              key={lead.ID}
              className={`p-4 border-b border-gray-100 cursor-pointer transition ${selectedLead === lead.ID
                ? 'bg-blue-50 border-l-4 border-l-blue-600'
                : 'hover:bg-gray-50'
                }`}
            >
              <div className="flex items-start gap-3">
                {/* Checkbox for selection */}
                <input
                  type="checkbox"
                  checked={selectedLeads.includes(lead.ID)}
                  onChange={(e) => {
                    e.stopPropagation();
                    handleSelectLead(lead.ID);
                  }}
                  onClick={(e) => e.stopPropagation()}
                  className="mt-3 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <div className="lead-avatar-circular-container">
                  {(() => {
                    const name = lead.PersonName || 'Unknown';
                    const scheme = getAvatarColorScheme(name);
                    return (
                      <>
                        <ScoreCard 
                          leadId={lead.ID || lead.LeadId || lead.Id}
                          personName={lead.PersonName} 
                          mobileNo={lead.MobileNo}
                        >
                          <div 
                            className="avatar-circle" 
                            style={{ backgroundColor: scheme.bg, color: scheme.text }}
                          >
                            {getInitials(name)}
                          </div>
                        </ScoreCard>
                        
                        {/* Followup Count Badge */}
                        <div className="score-badge-wrapper">
                          <span className="score-badge">{lead.FollowupCount || 0}</span>
                        </div>

                        {/* Call Icon Overlay */}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setScheduleLead(lead);
                            setShowScheduleModal(true);
                          }}
                          className="call-overlay-btn"
                          title="Schedule Call"
                        >
                          <BsTelephonePlus size={20} />
                        </button>
                      </>
                    );
                  })()}
                </div>
                <div className="flex-1 min-w-0" onClick={() => onSelectLead(lead)}>
                  <div className="flex flex-col mb-1">
                    <div className="flex items-center gap-2">
                      <h3 className="font-semibold text-gray-900 text-sm">
                        {lead.PersonName}
                      </h3>
                    </div>
                    <div className="flex justify-between items-center mt-1">
                      <div className="text-xs text-gray-500">
                        {lead.CreatedOn || ''}
                      </div>
                      <div className="flex items-center gap-2">
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            // open PDF modal for this lead
                            const leadNo = lead.LeadNo || lead.LeadId || lead.ID || lead.Id || '';
                            setPdfLeadNo(String(leadNo || ''));
                            setPdfLeadId(lead.ID || lead.Id || lead.LeadId || null);
                            setPdfSelectedCols(new Set());
                            setPdfTimeStamp(false);
                            setPdfCreatedBy(false);
                            setPdfPageNo(false);
                            setPdfTitle('');
                            setPdfModalOpen(true);
                            // fetch headers/preferences when modal opens (handled in effect)
                          }}
                          className="p-1 rounded text-gray-600 hover:bg-gray-100"
                          title="Create PDF"
                        >
                          <Download className="w-4 h-4" />
                        </button>
                        <CustomButtonDropdown
                          buttons={customButtons}
                          placeOnPage="InRecord"
                          onButtonClick={(button) => handleCustomButtonAction(button, resolveLeadId(lead))}
                        />
                      </div>
                    </div>
                  </div>
                  <p className="text-xs text-gray-600 mb-2">{lead.MobileNo}</p>
                  {/* {console.log(`lead`, lead)} */}
                  <span
                    className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${getStatusColor(lead)}`}
                  >
                    {lead.FollowupStatus}
                  </span>
                </div>
              </div>
            </div>
          ))
        )}

        {/* Inline Loading Indicator */}
        {isLoading && leads.length > 0 && (
          <div className="p-4 flex items-center justify-center">
            <RefreshCw className="w-5 h-5 animate-spin text-blue-600" />
            <span className="ml-2 text-sm text-gray-600">Loading more...</span>
          </div>
        )}
      </div>
      <PopUpModal
        isOpen={isImportDataModal}
        onClose={() => setIsImportDataModal(false)}
        title="Import Data"
        size="lg"
        footer={
          <div className="flex justify-between w-full">
            <Button
              variant="secondary"
              onClick={() => setIsImportDataModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              onClick={() => {
                if (typeof importSubmitHandler === 'function') {
                  importSubmitHandler();
                }
              }}
            >
              Upload
            </Button>
          </div>
        }
      >
        <ImportData
          onClose={() => setIsImportDataModal(false)}
          onSubmit={() => {
            setIsImportDataModal(false);
            window.location.reload();
          }}
          registerSubmitHandler={setImportSubmitHandler}
        />
      </PopUpModal>
      {showScheduleModal && (
        <PopUpModal isOpen={showScheduleModal} onClose={() => setShowScheduleModal(false)} title="Schedule Call">
          <ScheduleCallForm
            lead={scheduleLead}
            onCancel={() => setShowScheduleModal(false)}
            onSave={(data) => {
              console.debug('scheduled call', data, 'for', scheduleLead);
              setShowScheduleModal(false);
            }}
          />
        </PopUpModal>
      )}


      {/* ------------------------------------------------Mass Operation Modal---------------------- */}

      <PopUpModal
        isOpen={isMassAddFollowupModal}
        onClose={() => {
          setIsMassAddFollowupModal(false)
          setMassAssignSubmitHandler(null)
        }}
        title="AddAssignTo"
        size="lg"
        footer={
          <div className="flex justify-between w-full">
            <Button
              variant="secondary"
              onClick={() => {
                setIsMassAddFollowupModal(false)
                setMassAssignSubmitHandler(null)
              }}
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              onClick={() => {
                if (typeof massAssignSubmitHandler === 'function') {
                  massAssignSubmitHandler()
                }
              }}
            >
              Save
            </Button>
          </div>
        }
      >
        <AddAssignToMassOperation
          selectedCount={selectedLeads?.length}
          onClose={() => {
            setIsMassAddFollowupModal(false)
            setMassAssignSubmitHandler(null)
          }}
          registerSubmitHandler={setMassAssignSubmitHandler}
          {...massOperationSelectionProps}
        />
      </PopUpModal>

      <PopUpModal
        isOpen={isMassAddFollowupOperation}
        onClose={() => {
          setIsMassAddFollowupOperation(false)
          setMassFollowupSubmitHandler(null)
        }}
        title="Mass Add Followup"
        size="lg"
        footer={null}
      >
        <AddFollowupMassOperation
          mode="followup"
          selectedCount={selectedLeads?.length}
          onClose={() => {
            setIsMassAddFollowupOperation(false)
            setMassFollowupSubmitHandler(null)
          }}
          registerSubmitHandler={setMassFollowupSubmitHandler}
          {...massOperationSelectionProps}
        />
      </PopUpModal>

      <PopUpModal
        isOpen={isMassSendSMS}
        onClose={() => {
          setIsMassSendSMS(false)
          setMassSmsSubmitHandler(null)
        }}
        title="Send SMS"
        size="lg"
        footer={
          <div className="flex justify-between w-full">
            <Button
              variant="secondary"
              onClick={() => {
                setIsMassSendSMS(false)
                setMassSmsSubmitHandler(null)
              }}
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              onClick={() => {
                if (typeof massSmsSubmitHandler === 'function') {
                  massSmsSubmitHandler()
                }
              }}
            >
              Save
            </Button>
          </div>
        }
      >
        <SendSMS
          selectedCount={selectedLeads?.length + 1}
          onClose={() => {
            setIsMassSendSMS(false)
            setMassSmsSubmitHandler(null)
          }}
          registerSubmitHandler={setMassSmsSubmitHandler}
          {...massOperationSelectionProps}
        />
      </PopUpModal>

      <PopUpModal
        isOpen={isMassSendMail}
        onClose={() => {
          setIsMassSendMail(false)
          setMassMailSubmitHandler(null)
        }}
        title="Send Mail"
        size="lg"
        footer={
          <div className="flex justify-between w-full">
            <Button
              variant="secondary"
              onClick={() => {
                setIsMassSendMail(false)
                setMassMailSubmitHandler(null)
              }}
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              onClick={() => {
                if (typeof massMailSubmitHandler === 'function') {
                  massMailSubmitHandler()
                }
              }}
            >
              Save
            </Button>
          </div>
        }
      >
        <SendMail
          selectedCount={selectedLeads?.length + 1}
          onClose={() => {
            setIsMassSendMail(false)
            setMassMailSubmitHandler(null)
          }}
          registerSubmitHandler={setMassMailSubmitHandler}
          {...massOperationSelectionProps}
        />
      </PopUpModal>

      <PopUpModal
        isOpen={isMassSendVoiceBroadCast}
        onClose={() => {
          setIsMassSendVoiceBroadCast(false)
          setMassVoiceSubmitHandler(null)
        }}
        title="Send Voice BroadCast"
        size="lg"
        footer={
          <div className="flex justify-between w-full">
            <Button
              variant="secondary"
              onClick={() => {
                setIsMassSendVoiceBroadCast(false)
                setMassVoiceSubmitHandler(null)
              }}
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              onClick={() => {
                if (typeof massVoiceSubmitHandler === 'function') {
                  massVoiceSubmitHandler()
                }
              }}
            >
              Save
            </Button>
          </div>
        }
      >
        <VoiceBroadCast
          selectedCount={selectedLeads?.length + 1}
          onClose={() => {
            setIsMassSendVoiceBroadCast(false)
            setMassVoiceSubmitHandler(null)
          }}
          registerSubmitHandler={setMassVoiceSubmitHandler}
          {...massOperationSelectionProps}
        />
      </PopUpModal>

      <PopUpModal
        isOpen={isMassUpdateLead}
        onClose={() => setIsMassUpdateLead(false)}
        title="Mass Update Lead"
        size="lg"
        footer={
          <div className="flex justify-between w-full">
            <Button
              variant="secondary"
              onClick={() => setIsMassUpdateLead(false)}
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              onClick={() => {
                if (typeof massUpdateSubmitHandler === 'function') {
                  massUpdateSubmitHandler()
                }
              }}
            >
              Save
            </Button>
          </div>
        }
      >
        <UpdateForm
          selectedCount={selectedLeads?.length + 1}
          registerSubmitHandler={setMassUpdateSubmitHandler}
          {...massOperationSelectionProps}
        />
      </PopUpModal>

      <PopUpModal
        isOpen={isMassAddTask}
        onClose={() => {
          setIsMassAddTask(false)
          setMassTaskSubmitHandler(null)
        }}
        title="Mass Add Task"
        size="lg"
        footer={
          <div className="flex justify-between w-full">
            <Button
              variant="secondary"
              onClick={() => {
                setIsMassAddTask(false)
                setMassTaskSubmitHandler(null)
              }}
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              onClick={() => {
                if (typeof massTaskSubmitHandler === 'function') {
                  massTaskSubmitHandler()
                }
              }}
            >
              Save
            </Button>
          </div>
        }
      >
        <AddTaskForm
          selectedCount={selectedLeads?.length}
          onClose={() => {
            setIsMassAddTask(false)
            setMassTaskSubmitHandler(null)
          }}
          registerSubmitHandler={setMassTaskSubmitHandler}
          {...massOperationSelectionProps}
        />
      </PopUpModal>

      <PopUpModal
        isOpen={isMassAddAppointment}
        onClose={() => {
          setIsMassAddAppointment(false)
          setMassAppointmentSubmitHandler(null)
        }}
        title="Mass Add Appointment"
        size="lg"
        footer={
          <div className="flex justify-between w-full">
            <Button
              variant="secondary"
              onClick={() => {
                setIsMassAddAppointment(false)
                setMassAppointmentSubmitHandler(null)
              }}
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              onClick={() => {
                if (typeof massAppointmentSubmitHandler === 'function') {
                  massAppointmentSubmitHandler()
                }
              }}
            >
              Save
            </Button>
          </div>
        }
      >
        <AddAppointmentForm
          selectedCount={selectedLeads?.length}
          onClose={() => {
            setIsMassAddAppointment(false)
            setMassAppointmentSubmitHandler(null)
          }}
          registerSubmitHandler={setMassAppointmentSubmitHandler}
          {...massOperationSelectionProps}
        />
      </PopUpModal>

      <PopUpModal
        isOpen={isMassMsrketingSequence}
        onClose={() => {
          setIsMassMarketingSequence(false)
          setMassSequenceSubmitHandler(null)
        }}
        title="Mass Marketing Sequence"
        size="lg"
        footer={
          <div className="flex justify-between w-full">
            <Button
              variant="secondary"
              onClick={() => {
                setIsMassMarketingSequence(false)
                setMassSequenceSubmitHandler(null)
              }}
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              onClick={() => {
                if (typeof massSequenceSubmitHandler === 'function') {
                  massSequenceSubmitHandler()()
                }
              }}
            >
              Save
            </Button>
          </div>
        }
      >
        <MarkettingSequence
          selectedCount={selectedLeads?.length + 1}
          onClose={() => {
            setIsMassMarketingSequence(false)
            setMassSequenceSubmitHandler(null)
          }}
          registerSubmitHandler={setMassSequenceSubmitHandler}
          {...massOperationSelectionProps}
        />
      </PopUpModal>

      <PopUpModal
        isOpen={isSendInternationalSMS}
        onClose={() => {
          setIsSendInternationalSMS(false)
          setMassInternationalSmsSubmitHandler(null)
        }}
        title="Send International SMS"
        size="lg"
        footer={
          <div className="flex justify-between w-full">
            <Button
              variant="secondary"
              onClick={() => {
                setIsSendInternationalSMS(false)
                setMassInternationalSmsSubmitHandler(null)
              }}
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              onClick={() => {
                if (typeof massInternationalSmsSubmitHandler === 'function') {
                  massInternationalSmsSubmitHandler()
                }
              }}
            >
              Save
            </Button>
          </div>
        }
      >
        <SendInternationalSMS
          onClose={() => {
            setIsSendInternationalSMS(false)
            setMassInternationalSmsSubmitHandler(null)
          }}
          registerSubmitHandler={setMassInternationalSmsSubmitHandler}
          {...massOperationSelectionProps}
        />
      </PopUpModal>

      <PopUpModal
        isOpen={isMassAddTag}
        onClose={() => {
          setIsMassAddTag(false)
          setMassTagSubmitHandler(null)
        }}
        title={isAddTag ? "Mass Add Tag" : "Mass Remove Tag"}
        size="lg"
        footer={
          <div className="flex justify-between w-full">
            <Button
              variant="secondary"
              onClick={() => {
                setIsMassAddTag(false)
                setMassTagSubmitHandler(null)
              }}
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              onClick={() => {
                if (typeof massTagSubmitHandler === 'function') {
                  massTagSubmitHandler()
                }
              }}
            >
              Save
            </Button>
          </div>
        }
      >
        <AddRemoveTag
          mode={isAddTag ? 'add' : 'remove'}
          selectedCount={selectedLeads?.length + 1}
          onClose={() => {
            setIsMassAddTag(false)
            setMassTagSubmitHandler(null)
          }}
          registerSubmitHandler={setMassTagSubmitHandler}
          {...massOperationSelectionProps}
        />
      </PopUpModal>

      <PopUpModal
        isOpen={isMassAddCallList}
        onClose={() => {
          setIsMassAddCallList(false)
          setMassCallListSubmitHandler(null)
        }}
        title="Mass Add Call List"
        size="lg"
        footer={
          <div className="flex justify-between w-full">
            <Button
              variant="secondary"
              onClick={() => {
                setIsMassAddCallList(false)
                setMassCallListSubmitHandler(null)
              }}
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              onClick={() => {
                if (typeof massCallListSubmitHandler === 'function') {
                  massCallListSubmitHandler()
                }
              }}
            >
              Save
            </Button>
          </div>
        }
      >
        <AddCallList
          selectedCount={selectedLeads?.length + 1}
          registerSubmitHandler={setMassCallListSubmitHandler}
          {...massOperationSelectionProps}
        />
      </PopUpModal>

      <Modal
        isOpen={isDeleteMassConfirmModal.show}
        onClose={() => setDeleteMassConfirmModal({ show: false, leadId: null })}
        title="Mass Delete Lead"
        size="sm"
        showCloseButton={false}
        footer={
          <>
            <Button
              variant="outline"
              onClick={() => setDeleteMassConfirmModal({ show: false, leadId: null })}
            >
              No
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                handleMassDelete();
              }}
            >
              Yes
            </Button>
          </>
        }
      >
        <p className="text-gray-700">
          You are about to perform a mass delete action on <strong>{selectAllLeads ? totalRecord : selectedLeads?.length}</strong> selected record(s).
        </p>
      </Modal>

      {/* ------------------------------------------------End Mass Operation Modal---------------------- */}

      <PopUpModal
        isOpen={isAddLeadModal}
        onClose={() => setIsAddLeadModal(false)}
        title="Add Lead"
        size="lg"
      >
        <AddLeadForm
          onClose={() => setIsAddLeadModal(false)}
          onSaved={() => {
            setIsAddLeadModal(false);
            window.location.reload();
          }}
        />
      </PopUpModal>

      {/* PDF Columns Modal */}
      <PopUpModal
        isOpen={pdfModalOpen}
        onClose={() => setPdfModalOpen(false)}
        title="Select Title & Column"
        size="lg"
        footer={
          <div className="flex justify-between w-full">
            <Button variant="secondary" onClick={() => setPdfModalOpen(false)}>Cancel</Button>
            <div className="flex items-center gap-2">
              <Button variant="primary" onClick={handleGeneratePdf}>
                <Download className="w-4 h-4 mr-2" /> PDF
              </Button>
            </div>
          </div>
        }
      >
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700">Title</label>
              <input
                type="text"
                value={pdfTitle}
                onChange={(e) => setPdfTitle(e.target.value)}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm p-2"
                placeholder="Enter PDF title"
              />
            </div>
            <div className="ml-4 flex items-center gap-3">
              <label className="inline-flex items-center text-sm">
                <input type="checkbox" checked={pdfTimeStamp} onChange={(e) => setPdfTimeStamp(e.target.checked)} className="mr-2" /> Time Stamp
              </label>
              <label className="inline-flex items-center text-sm">
                <input type="checkbox" checked={pdfCreatedBy} onChange={(e) => setPdfCreatedBy(e.target.checked)} className="mr-2" /> Created By
              </label>
              <label className="inline-flex items-center text-sm">
                <input type="checkbox" checked={pdfPageNo} onChange={(e) => setPdfPageNo(e.target.checked)} className="mr-2" /> Page No.
              </label>
            </div>
          </div>

          <div className="border rounded">
            <div className="bg-gray-100 px-4 py-2 flex items-center justify-between">
              <div className="font-semibold text-sm">COLUMN NAME</div>
              <div className="flex items-center gap-4">
                <label className="inline-flex items-center text-sm">
                  <input type="checkbox" onChange={handleSelectAllPdf} checked={(pdfHeaders || []).length > 0 && (pdfHeaders || []).map(h => getHeaderName(h)).every(c => pdfSelectedCols.has(c))} className="mr-2" /> SELECT ALL
                </label>
              </div>
            </div>
            <div className="max-h-72 overflow-y-auto">
              <table className="w-full text-sm">
                <tbody>
                  {(pdfHeaders || []).map((h, idx) => {
                    const name = getHeaderName(h);
                    if (!name) return null;
                    const checked = pdfSelectedCols.has(name);
                    return (
                      <tr key={idx} className="border-b">
                        <td className="px-4 py-2">{name}</td>
                        <td className="w-28 px-4 py-2 text-right">
                          <input type="checkbox" checked={checked} onChange={() => togglePdfColumn(name)} />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </PopUpModal>

      <WebhookParamsModal
        isOpen={webhookModalState.open}
        onClose={() => setWebhookModalState({ open: false, webhookId: '', requiredParams: {}, leadIds: [], batchId: '', title: 'Webhook Parameters' })}
        title={webhookModalState.title}
        requiredParams={webhookModalState.requiredParams}
        placeholders={leadPlaceholders}
        onSubmit={({ params, headerKey, headerValue, senderId }) => submitWebhookAction({
          webhookId: webhookModalState.webhookId,
          params,
          leadIds: webhookModalState.leadIds,
          batchId: webhookModalState.batchId,
          headerKey,
          headerValue,
          senderId
        })}
      />

    </div>
  );
};

export default LeadList;
